import React, { useContext } from "react";
import OwButton from "../../../shared/OwButton/OwButton";
import SupplierContext from "../../../../contexts/SupplierContext";

type Props = {
    openCatalogViewer: () => void;
    openCategoryViewer: () => void;
    openRecentItemsSidebar: () => void;
    selectedCatalogOptions?: { catalogGuid: string; catalogName: string; catalogId: number; hasCategories?: boolean };
    retrievedWarehouses: boolean;
    retrievingWarehouses: boolean;
};

export const ItemLookupButtonSet = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const hideCategoryViewer = (): boolean => {
        let hideViewer = false;

        if (supplierModel.hide_category_viewer) {
            hideViewer = true;
        }

        if (props.selectedCatalogOptions) {
            if (!props.selectedCatalogOptions.hasCategories) {
                hideViewer = true;
            }
        }

        return hideViewer;
    };

    return (
        <div className={"ItemLookupButtonSet mt-2 mt-sm-0"}>
            <div className={"d-flex"}>
                {supplierModel.hide_catalog_viewer ? null : (
                    <div>
                        <OwButton
                            id={"catalogViewer"}
                            className={"btn-warning me-2"}
                            fn={props.openCatalogViewer}
                            title={"catalog_viewer"}
                            leftIconClass={"d-none d-md-inline-flex fas fa-book"}
                            btnSizeClass={" "}
                        />
                    </div>
                )}

                {hideCategoryViewer() ? null : (
                    <div>
                        <OwButton
                            id={"categoryViewer"}
                            className={"btn-warning me-2"}
                            fn={props.openCategoryViewer}
                            title={"category_viewer"}
                            leftIconClass={"d-none d-md-inline-flex fas fa-sitemap"}
                            btnSizeClass={" "}
                            disabled={!props.retrievedWarehouses}
                            active={props.retrievingWarehouses}
                            disableOnActive={props.retrievingWarehouses}
                        />
                    </div>
                )}

                <div>
                    <OwButton
                        className={"btn-warning"}
                        fn={props.openRecentItemsSidebar}
                        title={"recent_items"}
                        leftIconClass={"d-none d-md-inline-flex fas fa-history"}
                        btnSizeClass={" "}
                        disabled={!props.retrievedWarehouses}
                        active={props.retrievingWarehouses}
                        disableOnActive={props.retrievingWarehouses}
                    />
                </div>
            </div>
        </div>
    );
};
